/* Library */
import React, { Component } from 'react';
import _ from 'lodash';

import TextInput from '../../../../../components/ZUILib/TextInput';
import CalenderSample from '../../../../../components/ZUILib/CalenderSample';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import { eventType, ownerLabel, constChannel } from '../../../../../utils/clientConstant';

import commonUtil from '../../../../../utils/commonUtil';
import CheckBox from '../../../../../components/ZUILib/CheckBox/CheckBox';
import { createTagsForInvalidFormControls } from '../../../../../utils/googleTagManagerUtils';

const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

const channel = commonUtil.getChannel();

export default class EventCoOwnerType3 extends Component {
  constructor(props) {
    super(props);
    this.checkboxdetails = {
      emailDetail: '',
    };
    this.formData = {
      userData: {
        title: '',
        ownerLabel: '',
        profileId: '',
        firstName: '',
        lastName: '',
        nickName: '',
        phone: '',
        dateOfBirth: '',
        email: '',
        isMinor: '',
        is_coowner: '',
        sex: '',
        motherName: '',
      },
    };
    this.emailID = '';
    this.minorCheck = this.minorCheck.bind(this);
    this.permitAccess = this.permitAccess.bind(this);
    this.displayCoOwnerDetails = this.displayCoOwnerDetails.bind(this);
    this.displayCoOwnerDetailsChk = this.displayCoOwnerDetailsChk.bind(this);
    this.isPermit = this.props.isPermit;
    this.coOwnerOptional = this.props.optional;
    this.ownerLabel = '';
  }
  componentDidMount() {
    if (this.props.eventName === eventType.Fiesta_Infantil && this.COwnerChecked && this.COwnerChecked.label) {
      const labelCelebrated = this.props && this.props.eventDetail && this.props.eventDetail.labels && this.props.eventDetail.labels.filter(item => item.toLowerCase().includes(ownerLabel.Celebrated));
      this.COwnerChecked.label.innerText = 'Agregar ' + (labelCelebrated || ownerLabel.Celebrated);
      this.COwnerChecked.setChecked(true);
      this.COwnerChecked.setDisabled(true);
      this.controls.style.display = 'block';
      this.title.setSelectedValue('coOwnerOptions_1');
      this.minorCheckDisplay.style.display = 'block';
      this.minor.setChecked(true);
      this.minor.setDisabled(true);
      this.minorDisplay.style.display = 'block';
    }

    if (this.props.eventName !== eventType.Fiesta_Infantil && this.props.ownerTitle && this.props.ownerTitle.toLowerCase().includes(ownerLabel.Celebrated)) {
      if (this.props.userData && this.props.userData.title) {
        const option = {};
        option.value = this.props.userData.title;
        this.displayCoOwnerDetails(option);
      } else {
        this.selectedOpton.style.display = 'block';
      }
      const labelAdmintrator = this.props && this.props.eventDetail && this.props.eventDetail.labels && this.props.eventDetail.labels.filter(item => item.toLowerCase().includes(ownerLabel.CoAdministrator));
      this.COwnerChecked.label.innerText = 'Agregar ' + (labelAdmintrator || ownerLabel.CoAdministrator);
      this.coOwnerRole.style.display = 'block';
      if (this.props.userData && this.props.userData.isMinor === 'true') {
        this.minor.setChecked(true);
        this.minorCheck();
      }
    }
    if (this.props.eventName !== eventType.Fiesta_Infantil && this.props.ownerTitle && this.props.ownerTitle.toLowerCase().includes(ownerLabel.Organizer)) {
      if (this.props.userData && this.props.userData.title) {
        const option = {};
        option.value = this.props.userData.title;
        this.displayCoOwnerDetails(option);
      }
      const labelCelebrated = this.props && this.props.eventDetail && this.props.eventDetail.labels && this.props.eventDetail.labels.filter(item => item.toLowerCase().includes(ownerLabel.Celebrated));
      this.COwnerChecked.label.innerText = 'Agregar ' + (labelCelebrated || ownerLabel.Celebrated);
      this.coOwnerRole.style.display = 'none';
      this.COwnerChecked.setDisabled(true);
      if (this.props.userData && this.props.userData.isMinor === 'true') {
        this.minor.setChecked(true);
        this.minorCheck();
      }
    }
    if (this.emailID) {
      this.showEmailData.setChecked(true);
      this.permitAccess();
    }
    if (this.props.userData && this.props.userData.dateOfBirth) {
      this._CalenderSample.setDate(this.props.userData.dateOfBirth);
    }
  }

  getformData = () => this.formData.userData

  onPasteFunc = (e) => {
    const text = e.clipboardData.getData('Text');
    const numericValue = text ? text.replace(/\D/g, '') : '';
    if (text !== numericValue) {
      e.preventDefault();
    }
  }
  handleAllowOnlyDigit = (e) => {
    const keyCode = e.charCode;
    if (keyCode > 37 && (keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  }

  handleformValidate = () => {
    const ownerEmailId = this.props.ownerEmailId ? this.props.ownerEmailId : null;
    let isFormValid = true;

    let titleValid = true;
    let firstNameValid = true;
    let lastNameValid = true;
    let emailValid = true;
    let birthDateValid = true;
    let maternalNameValid = true;
    let nickNameValid = true;
    let cellularValid = true;

    if (this.COwnerChecked.isChecked()) {
      const titleValidValidationConfig = {
        functionRef: commonUtil.validateSelectedValue, funcData: [this.title.getSelectedIndex()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required'),
      };
      titleValid = commonUtil.validateSelecteTab(titleValidValidationConfig, this.title, null);

      const firstNameValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.txtFirstName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.txtFirstName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      firstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.txtFirstName, null);

      const lastNameValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.txtLastName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.txtLastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      lastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.txtLastName, null);

      const maternalNameValidationRules = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.txtMotherName.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.txtMotherName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      maternalNameValid = commonUtil.validateTextInput(maternalNameValidationRules, this.txtMotherName, null);
    
      const birthDateValidationRules = {
        functionRef: commonUtil.isValueAvailable, funcData: [this._CalenderSample.state.date], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required')
      };
      birthDateValid = commonUtil.validateCalendarInput(birthDateValidationRules, this._CalenderSample, null);
    }
    if (this.isPermit && this.COwnerChecked.isChecked()) {
      const emailValidationRules = [
        { functionRef: commonUtil.compareEmail, funcData: [this.txtEmail.getValue(), ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error') },
        { functionRef: commonUtil.validateEmail, funcData: [this.txtEmail.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      emailValid = commonUtil.validateTextInput(emailValidationRules, this.txtEmail, null);
    }

    if (this.txtnickName.getValue()) {
      const nickNameValidationRules = [
        // { functionRef: commonUtil.validateLength, funcData: [this.txtnickName.getValue(), 1], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
        { functionRef: commonUtil.validateNameForAlphaNumeric, funcData: [this.txtnickName.getValue(), 1, false], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      nickNameValid = commonUtil.validateTextInput(nickNameValidationRules, this.txtnickName, null);
    }
    if (this.txtCellular.getValue()) {
      const CellularValidationRules = [
        { functionRef: commonUtil.validateNumber, funcData: [this.txtCellular.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      cellularValid = commonUtil.validateTextInput(CellularValidationRules, this.txtCellular, null);
    }

    isFormValid = (titleValid && firstNameValid && lastNameValid && emailValid && birthDateValid && maternalNameValid && nickNameValid && cellularValid);

    if (isFormValid) {
      this.formData = {
        userData: {
          title: this.title.getValue(),
          ownerLabel: this.ownerLabel,
          profileId: '',
          firstName: this.txtFirstName.getValue(),
          lastName: this.txtLastName.getValue(),
          motherName: this.txtMotherName.getValue(),
          nickName: this.txtnickName.getValue(),
          phone: this.txtCellular.getValue(),
          dateOfBirth: this._CalenderSample.state.date,
          isMinor: this.minor.isChecked() ? 'true' : 'false',
          email: this.isPermit && this.showEmailData.isChecked() ? this.txtEmail.getValue().toLowerCase() : '',
          is_coowner: 'true',
          sex: '',
        },
      };
      return true;
    }

    const controls = [this.title, this.txtFirstName, this.txtLastName, this.txtMotherName, this._CalenderSample, this.txtEmail, this.txtnickName, this.txtCellular];
    const tagCompositor = c => ({
      event: 'alerta',
      phase: 'Crear mesa de regalos',
      step: 'Datos del festejado',
      color: 'Rojo',
      mensaje: 'Datos incompletos del festejado 2',
      mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
      seccion: 'Mesa de Regalos',
      tipo: 'formulario',
    });
    createTagsForInvalidFormControls({ controls, tagCompositor });

    if (!titleValid) {
      this.props.focusOnError('id');
    } else if (!firstNameValid) {
      this.props.focusOnError('coOwner_firstname');
    } else if (!lastNameValid) {
      this.props.focusOnError('coOwner_lastname');
    } else if (!maternalNameValid) {
      this.props.focusOnError('coOwner_motherName');
    } else if (!nickNameValid) {
      this.props.focusOnError('coOwner_nickName');
    } else if (!birthDateValid) {
      this.props.focusOnError('calendar');
    } else if (!cellularValid) {
      this.props.focusOnError('phone');
    } else if (!emailValid) {
      this.props.focusOnError('email');
    }
    return false;
  }

  onOwnerRoleSelected = (ownerRole, flushRecord) => {
    if (this.props.eventName !== eventType.Fiesta_Infantil) {
      this.selectedOpton.style.display = 'none';
      this.coOwnerRole.style.display = 'none';
      this.controls.style.display = 'none';
      this.minorCheckDisplay.style.display = 'none';
      this.COwnerChecked.setChecked(false);
      this.COwnerChecked.setDisabled(false);
      this.showEmailData.setChecked(false);
      if (flushRecord) {
        this.title.clearSelectedData();
        this.txtFirstName.setValue('');
        this.txtLastName.setValue('');
        this.txtMotherName.setValue('');
        this.txtnickName.setValue('');
        this.txtCellular.setValue('');
        this._CalenderSample.clearSelectedData();
      }
      this.permitAccess();
      if (ownerRole) {
        this.selectedOpton.style.display = 'block';
        if (ownerRole.toLowerCase().includes(ownerLabel.Organizer)) {
          this.COwnerChecked.setChecked(true);
          this.COwnerChecked.setDisabled(true);
          this.controls.style.display = 'block';
          this.minorCheckDisplay.style.display = 'block';
          this.title.setSelectedValue('coOwnerOptions_1');
          const labelCelebrated = this.props && this.props.eventDetail && this.props.eventDetail.labels && this.props.eventDetail.labels.filter(item => item.toLowerCase().includes(ownerLabel.Celebrated));
          this.COwnerChecked.label.innerText = 'Agregar ' + (labelCelebrated || ownerLabel.Celebrated);
          this.ownerLabel = labelCelebrated[0] || ownerLabel.Celebrated;
        } else {
          this.coOwnerRole.style.display = 'block';
          this.minorCheckDisplay.style.display = 'none';
          const labelAdmintrator = this.props && this.props.eventDetail && this.props.eventDetail.labels && this.props.eventDetail.labels.filter(item => item.toLowerCase().includes(ownerLabel.CoAdministrator));
          this.COwnerChecked.label.innerText = 'Agregar ' + (labelAdmintrator || ownerLabel.CoAdministrator);
          this.ownerLabel = labelAdmintrator[0] || ownerLabel.CoAdministrator;
        }
      }
    }
  }

  minorCheck(option) {
     
    this.props.toggleDisclaimer();
    if (this.minor.isChecked()) {
      this.minorDisplay.style.display = 'block';
       this.forCheckNew.style.display = 'block';
    } else {
      this.minorDisplay.style.display = 'none';
       this.forCheckNew.style.display = 'none';
    }
  }
  handleCheckBox = (option) => {
    if (this.minor.isChecked()) {
       this.forCheckNew.style.display = 'block';
    } else {
       this.forCheckNew.style.display = 'none';
    }

  }

  permitAccess() {
    if (this.showEmailData.isChecked() && this.COwnerChecked.isChecked()) {
      this.isPermit = true;
      this.forCheck.style.display = 'block';
    } else {
      this.isPermit = false;
      this.forCheck.style.display = 'none';
    }
  }

  displayCoOwnerDetails(opt) { // To show/hide coOwnerData for baby event rather for wedding/anniversary will always show.
    this.selectedOpton.style.display = 'none';
    if (opt.value) {
      this.COwnerChecked.setChecked(true);
      this.controls.style.display = 'block';
      this.selectedOpton.style.display = 'block';
    }
  }   

   displayOthersDetails(selectedTitle) {
    
    if (selectedTitle.value === true) {
       this.controlsBlock.style.display = 'block';
    } else {
       this.controlsBlock.style.display = 'none';
    }
  }

  displayCoOwnerDetailsChk(opt) {
    this.controls.style.display = 'none';
    if (opt.checked) {
      this.controls.style.display = 'block';
      this.minorCheckDisplay.style.display = 'none';
    } else {
      this.title.clearSelectedData();
      this.txtFirstName.setValue('');
      this.txtLastName.setValue('');
      this.txtMotherName.setValue('');
      this.txtnickName.setValue('');
      this.txtCellular.setValue('');
      this._CalenderSample.clearSelectedData();
    }
  }
  handlePopUpCoOwner = (id) => {
    if (channel === 'wap') {
      const data = document.querySelector('#' + id);
      if (data.style.display === 'block') {
        data.style.display = 'none';
      } else {
        data.style.display = 'block';
      }
    }
  }
  render() {
    const { eventDetail, userData, lables } = this.props;
    let SelectionOptions = [];
    const textInputAttr = {
      textClassName: 'form-control',
      textLabelClassName: 'label_one',
      textHtmlId: 'calendar',
      textPlaceholder: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.dob.label'),
      textRequired: true,
    };

    this.emailID = (userData && userData.email) ? userData.email : '';

    SelectionOptions = eventDetail.titles.map((data, index) => {
      const title = {};
      title.id = 'coOwnerOptions_' + index;
      title.labelResourceId = data;
      title.value = data;
      return title;
    });

    if (this.props.eventName === eventType.Fiesta_Infantil && this.COwnerChecked && this.COwnerChecked.label) {
      const labelCelebrated = this.props && this.props.eventDetail && this.props.eventDetail.labels && this.props.eventDetail.labels.filter(item => item.toLowerCase().includes(ownerLabel.Celebrated));
      this.COwnerChecked.label.innerText = 'Agregar ' + (labelCelebrated || ownerLabel.Celebrated);
      this.ownerLabel = labelCelebrated[0] || ownerLabel.Celebrated;
      this.COwnerChecked.setChecked(true);
      this.COwnerChecked.setDisabled(true);
      this.controls.style.display = 'block';
      this.title.setSelectedValue('coOwnerOptions_1');
      this.minorCheckDisplay.style.display = 'block';
      this.minor.setChecked(true);
      this.minor.setDisabled(true);
    }
    return (
      <React.Fragment>
        
        <div 
        // style={{ display: (this.coOwnerOptional) ? 'none' : 'block' }} 
        ref={sValue => this.selectedOpton = sValue}
        >
          <div className={channel === 'web' ? 'formBlock' : 'formBlock p-l-20'}>
            <h2 className='subtitleModule_New_Three'> ¿Estás organizando con alguien más? </h2>
            <SelectionTab
                classname="cSelect required"
                id={'id'}
                options={[{id: 'yes', labelResourceId: 'Si', value:true}, {id: 'organ', labelResourceId: 'No', value:false}]}
                optionCaption={commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.selecttitle2.label')}
                optionText={'labelResourceId'}
                optionValue={'value'}
                value={userData && userData.title ? userData.title : null}
                star="*"
                required="true"
                ref={el => (this.title = el)}
                handleSelectedOption={(selectedOption) => this.displayOthersDetails(selectedOption)}
                enable={SelectionOptions.length > 0}
              />
          </div>
          <div 
              style={{ display: 'none' }}
              className='formBlock_siblings'
               ref={sValue => this.controlsBlock = sValue}
            >
             <div className='formBlock'>
                <h2 className='subtitleModule_New_Three'>Agrega sus datos</h2>
              </div>
            <div className="formBlock">
              <TextInput
                doNotUpdateOnPropsChange="true"
                className="inputMaterial"
                labelClassName="placeHolderMaterial"
                htmlId="coOwner_firstname"
                label="Nombre"
                maxlength="100"
                star="*"
                value={userData ? userData.firstName : ''}
                required="true"
                ref={txtFirstName => this.txtFirstName = txtFirstName}
              />
            </div>
            <div className="formBlock">
              <TextInput
                doNotUpdateOnPropsChange="true"
                className="inputMaterial"
                labelClassName="placeHolderMaterial"
                htmlId="coOwner_lastname"
                label="Primer Apellido"
                maxlength="100"
                value={userData ? userData.lastName : ''}
                star="*"
                required="true"
                ref={txtLastName => this.txtLastName = txtLastName}
              />
            </div>
            <div className="formBlock">
              <TextInput
                doNotUpdateOnPropsChange="true"
                className="inputMaterial"
                labelClassName="placeHolderMaterial"
                htmlId="coOwner_motherName"
                required="true"
                label="Segundo Apellido"
                maxlength="100"
                star="*"
                value={userData ? userData.motherName : ''}
                ref={txtMotherName => this.txtMotherName = txtMotherName}
              />
            </div>
            <div className="formBlock">
            <div className="inLine input_help_icon">
                 <CheckBox htmlId={this.props.id + '_minor'} displayName="Invitar a administrar la mesa de regalos" ref={chkFor => this.minor = chkFor} getSelectedValue={this.handleCheckBox} />
                 <div className="iconHelp inLine"><i onClick={() => { this.handlePopUpCoOwner('helpPopUp'); }} className="icon-ayuda" />
                <div id="helpPopUp" className="popover bottom helpIconCss"><div className="arrow" />
                  <div className="popover-content">
                    <ul>
                      {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.alias.message')}
                    </ul>
                  </div>
                </div>
              </div>
              </div>
              </div>
        <div className="col-xs-12 col-sm-12 col-md-12 moreOptions" style={{ display: 'none' }} ref={(forCheck) => { this.forCheckNew = forCheck; }}>
            <div className="formBlock">
                {channel === constChannel.WEB ?
                  <TextInput
                    doNotUpdateOnPropsChange="true"
                    className="inputMaterial"
                    labelClassName="placeHolderMaterial"
                    htmlId="phone"
                    label="Celular"
                    required="false"
                    maxlength="10"
                    value={userData ? userData.phone : ''}
                    onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
                    onPaste={(e) => { this.onPasteFunc(e); }}
                    ref={txtCellular => this.txtCellular = txtCellular}
                  />
                :
                  <TextInput
                    doNotUpdateOnPropsChange="true"
                    className="inputMaterial"
                    labelClassName="placeHolderMaterial"
                    htmlId="phone"
                    label="Celular"
                    type="tel"
                    required="false"
                    maxlength="10"
                    value={userData ? userData.phone : ''}
                    onKeyPress={(e) => { this.handleAllowOnlyDigit(e); }}
                    onPaste={(e) => { this.onPasteFunc(e); }}
                    ref={txtCellular => this.txtCellular = txtCellular}
                  />
              }
              </div>
              <div className='formBlock'>
                <TextInput
                  doNotUpdateOnPropsChange="true"
                  className="inputMaterial"
                  labelClassName="placeHolderMaterial"
                  htmlId="coOwner_email"
                  label="Correo electrónico"
                  required="false"
                  star="*"
                  maxlength="100"
                  value={userData ? userData.email : ''}
                  ref={txtEmail => this.txtEmail = txtEmail}
                />
              </div>
              </div>
            {/* <div className="formBlock">
              <div className="inputDate input-group date" id="datetimepicker2">
                <CalenderSample
                  value={userData && userData.dateOfBirth ? userData.dateOfBirth : null}
                  textInputJSON={textInputAttr}
                  htmlId="calendar"
                  activeStartDate={this.props.currentDate}
                  minDate={this.props.startDate}
                  maxDate={this.props.currentDate}
                  viewType="decade"
                  ref={(refd) => { this._CalenderSample = refd; }}
                />
              </div>
             
              <div className="row">
                <div className="col-xs-12 col-sm-12 col-md-12 moreOptions" style={{ display: 'block' }} ref={chkFor => this.minorCheckDisplay = chkFor}>
                  <div className="formBlock">
                    <div className={channel === 'web' ? 'inLine addFestejado' : 'inLine addFestejado p-l-20'}>
                      <CheckBox htmlId={this.props.id + '_minor'} displayName="El festejado es menor de edad" ref={chkFor => this.minor = chkFor} getSelectedValue={this.minorCheck} />
                    </div>
                  </div>
                  <div className="formBlock descriptInfoAditional" style={{ display: 'none' }} ref={chkFor => this.minorDisplay = chkFor} dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.coOwner.permission') }} />
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 moreOptions">
                  <div className="formBlock">
                    <div className={channel === 'web' ? 'inLine' : 'inLine p-l-20'}>
                      <CheckBox htmlId={this.props.id + '_showEmail'} displayName={commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.permission.label')} ref={chk => this.showEmailData = chk} getSelectedValue={this.permitAccess} />
                    </div>
                    <div className="iconHelp inLine"><i onClick={() => { this.handlePopUpCoOwner('helpPopupOne'); }} className="icon-ayuda" />
                      <div id="helpPopupOne" className="popover bottom helpIconCssEmail"><div className="arrow" />
                        <div className="popover-content">
                          <ul dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.permissionAlias.message') }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 moreOptions permitAccess" style={{ display: 'none' }} ref={(forCheck) => { this.forCheck = forCheck; }}>
                  <div className="formBlock">
                    <p className="descriptInfoAditional">{commonUtil.getLabel(this.props.lables.createEventStep1, 'eventCreation.stage1.permissionToCoowner.notify')}</p>
                  </div>
                  <div className="formBlock">
                    <TextInput
                      doNotUpdateOnPropsChange="true"
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="email"
                      required="true"
                      star="*"
                      label={commonUtil.getLabel(this.props.lables.createLogin, 'create.account.email')}
                      maxlength="100"
                      value={this.emailID ? this.emailID : ''}
                      ref={txtEmail => this.txtEmail = txtEmail}
                    />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        {/* <div className="col-xs-12 col-sm-12 col-md-12">
          <div className={channel === 'web' ? 'tipBlockBasic' : 'tipBlock'}>
            <p><span>Tip:</span>{commonUtil.getLabel(this.props.lables.createEventStep1, 'createEventStep1.coOwner.tooltip')}</p>
          </div>
        </div> */}
      </React.Fragment>
    );
  }
}
